import React, { useContext } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coy } from "react-syntax-highlighter/dist/esm/styles/prism";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";
import GlobalContext from "../domain/GlobalContext";

interface CodeBlockProps {
  value: string;
  language?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ language = "javascript", value }) => {
  const { isDarkMode } = useContext(GlobalContext);

  return (
    <div className={isDarkMode ? "codeblock-dark" : "codeblock"}>
      <SyntaxHighlighter language={language} style={isDarkMode ? darcula : coy}>
        {value}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeBlock;